import { render, staticRenderFns } from "./ImagePreviews.vue?vue&type=template&id=244d7e6a&scoped=true&"
import script from "./ImagePreviews.vue?vue&type=script&lang=ts&"
export * from "./ImagePreviews.vue?vue&type=script&lang=ts&"
import style0 from "./ImagePreviews.vue?vue&type=style&index=0&id=244d7e6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244d7e6a",
  null
  
)

export default component.exports